import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  input,
  signal,
  viewChild
} from '@angular/core';

@Component({
  selector: 'comp-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-collapsed]': 'isCollapsed()',
  },
})
export class DescriptionComponent {
  private readonly descriptionElement = viewChild<ElementRef<HTMLElement>>('descriptionElement');
  protected readonly hasOverflow = signal(true);

  readonly description = input.required<string | undefined>();
  readonly showMaxLines = input<number | undefined>(undefined);

  protected readonly isCollapsable = computed(
    () => this.showMaxLines() !== undefined && this.hasOverflow(),
  );

  protected readonly isCollapsed = signal(true);

  constructor() {
    effect(() => {
      this.isCollapsed.set(this.isCollapsable());
    });
  }

  ngAfterViewInit(): void {
    this.updateOverflowState();
  }

  private updateOverflowState(): void {
    const element = this.descriptionElement()?.nativeElement;

    if (!element || this.showMaxLines() === undefined) {
      this.hasOverflow.set(false);
      return;
    }

    this.hasOverflow.set(element.scrollHeight > element.clientHeight);
  }

  protected toggle(): void {
    this.isCollapsed.update((expanded) => !expanded);
  }

  //render a plain text description with line breaks as paragraphs
  protected readonly descriptionParagraphs = computed(() =>
    (this.description() || 'No description available').split(/\r?\n/),
  );
}
